import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContactAndAddressService } from '@services/contact-and-address/contact-and-address.service';
import { TranslateService } from '@services/translate/translate.service';
import { Models } from '@ibexfusion/models';
import { MessengerService } from '@services/messenger/messenger.service';
import { TimePickerComponent } from '../../../../../../components/time-picker/time-picker.component';

@Component({
    selector: 'edit-opening-hours-dialog',
    templateUrl: './edit-opening-hours-dialog.component.html',
    styleUrls: ['./edit-opening-hours-dialog.component.scss'],
    providers: [],
    standalone: false
})
export class EditOpeningHoursDialogComponent implements OnInit {

  translation: any;
  errorMessage;
  element: Models.OpeningInfo;
  titleError = false;
  sameTimeError = false;
  startDateError = false;
  endDateError = false;

  constructor(
      public dialogRef: MatDialogRef<EditOpeningHoursDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private ts: TranslateService, private dialog: MatDialog
  ) {
  }

  async ngOnInit() {
    const regularTitles = { de: 'Reguläre Öffnungszeiten', en: 'Regular opening hours', fr: 'Heures d\'ouverture régulières', it: 'Orari di apertura regolari' };
    this.translation = this.ts.get('dynamicContent');
    this.element = this.data.data[this.data.index] || new Models.OpeningInfo;
    if (!this.data.data[this.data.index]) {
      if (this.data.type === 'span' && this.data.data.find(el => !el.startDate && !el.endDate)) {
        const regular = this.data.data.find(el => !el.startDate && !el.endDate);
        delete regular.titles;
        regular.startDate = null;
        regular.endDate = null;
        this.element.populateFromJSON(regular);
        this.element.titles = Object.keys(this.data.translations).map(el => {
          const title = new Models.OpeningInfoTitle();
          title.populateFromJSON({ language: el, title: '' });
          return title;
        });
        this.element.days = regular.days.map(el => {
          const day = new Models.OpeningTimeDay();
          day.populateFromJSON(el);
          return day;
        });
        return;
      }
      this.element.titles = Object.keys(this.data.translations).map(el => {
        const title = new Models.OpeningInfoTitle();
        title.populateFromJSON({ language: el, title: this.data.type === 'regular' ? regularTitles[el] : '' });
        return title;
      });
      if (this.data.type === 'regular' || this.data.type === 'span') {
        this.element.days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(el => {
          const day = new Models.OpeningTimeDay();
          day.populateFromJSON({ open: false, day: el, times: [] });
          return day;
        });
      }
    }
  }

  getTitleField() {
    return this.element.titles.find(el => el.language === (this.data.language || 'de'));
  }

  async openTimePicker(day: Models.OpeningTimeDay | Models.OpeningInfo, index: number, type: string) {
    let dialogRef: MatDialogRef<TimePickerComponent>;
    dialogRef = this.dialog.open(TimePickerComponent, { width: '398px', height: '548px', panelClass: 'time', data: day.times[index][type] });
    let result = await dialogRef.afterClosed().toPromise();
    if (result) {
      result.hour = result.hour === 24 ? 0 : result.hour;
      day.times[index][type] = this.convertResultToString(result);
    }
  }

  convertResultToString(result: any): string {
    return `${String(result.hour).padStart(2, '0')}:${String(result.minute).padStart(2, '0')}`;
  }

  addTime(day: Models.OpeningTimeDay | Models.OpeningInfo) {
    day.times.push(new Models.OpeningTimes());
  }

  removeTime(day: Models.OpeningTimeDay | Models.OpeningInfo, index: number) {
    day.times.splice(index, 1);
  }

  initDay(day: Models.OpeningTimeDay, value: boolean) {
    day.open = value;
    day.times = day.times?.length ? day.times : [ new Models.OpeningTimes() ];
  }

  initElement(value) {
    this.element.open = value;
    this.element.times = this.element.times?.length ? this.element.times : [ new Models.OpeningTimes() ];
  }

  async save() {
    this.titleError = this.getTitleField().title?.length < 2;
    if (this.data.type === 'span' || this.data.type === 'day') {
      this.startDateError = !this.element.startDate;
    }
    if (this.data.type === 'span') {
      this.endDateError = !this.element.endDate;
      this.sameTimeError = !!this.element.days.find(d => d.open && !d.openFullDay && d.times.find(t => t.endTime === t.startTime));
    } else if (this.data.type === 'day') {
      this.sameTimeError = !this.element?.openFullDay && !!this.element.times.find(t => t.startTime === t.endTime);
    }
    if (this.titleError || this.startDateError || this.endDateError || this.sameTimeError) {
      return;
    }
    this.dialogRef.close(this.element);
  }
}
